import { render, staticRenderFns } from "./doctor-patient-invitation-report.vue?vue&type=template&id=a3c59f7e&"
import script from "./doctor-patient-invitation-report.vue?vue&type=script&lang=js&"
export * from "./doctor-patient-invitation-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports